/**
 * Ready-check line model (SOLY-PLAN-001 MS-23, AC4). Maps a work item's known inputs to human lines,
 * each marked ok (✓) or missing (!) from `readyCheck.missing`. Pure + ordered so the "voir le détail"
 * panel renders the same set every time. Keys mirror the BE `missing[]` contract.
 */
export interface ReadyLine {
  key: string
  label: string
  ok: boolean
}

const SURVEY_LINES: { key: string; label: string }[] = [
  { key: 'schedule', label: 'Date planifiée' },
  { key: 'surveyor', label: 'Métreur assigné' },
  { key: 'estimate', label: 'Durée estimée' },
  { key: 'clientConfirmation', label: 'Date confirmée' },
]

const INSTALL_LINES: { key: string; label: string }[] = [
  // "traité" covers both Completed and NotApplicable (a non-nécessaire métré satisfies this) — C3.
  { key: 'survey', label: 'Métré traité' },
  { key: 'supplierOrders', label: 'Commandes reçues' },
  // P1 (_constraints.md): the BE marks "installer" missing until assignees ≥ estimatedResourceCount,
  // so the drawer and the « Équipe incomplète » Suivi alert tell the same story.
  { key: 'installer', label: 'Équipe complète' },
  { key: 'clientConfirmation', label: 'Date confirmée' },
]

export function readyCheckLines(kind: 'survey' | 'installation', missing: string[]): ReadyLine[] {
  const set = new Set(missing)
  const lines = kind === 'survey' ? SURVEY_LINES : INSTALL_LINES
  return lines.map((l) => ({ ...l, ok: !set.has(l.key) }))
}
